{
  "CONTACTS_FILTER": {
    "TITLE": "Kontakte filtern",
    "SUBTITLE": "Fügen Sie unten Filter hinzu und klicken Sie auf 'Senden', um die Kontakte zu filtern.",
    "EDIT_CUSTOM_SEGMENT": "Segment bearbeiten",
    "CUSTOM_VIEWS_SUBTITLE": "Füge Filter hinzu oder entferne sie und aktualisieren dein Segment.",
    "ADD_NEW_FILTER": "Filter hinzufügen",
    "CLEAR_ALL_FILTERS": "Alle Filter löschen",
    "FILTER_DELETE_ERROR": "Sie sollten mindestens einen Filter zum Speichern haben",
    "SUBMIT_BUTTON_LABEL": "Einreichen",
    "UPDATE_BUTTON_LABEL": "Segment aktualisieren",
    "CANCEL_BUTTON_LABEL": "Abbrechen",
    "CLEAR_BUTTON_LABEL": "Filter zurücksetzen",
    "EMPTY_VALUE_ERROR": "Wert ist erforderlich",
    "SEGMENT_LABEL": "Segmentname",
    "SEGMENT_QUERY_LABEL": "Segment-Abfrage",
    "TOOLTIP_LABEL": "Kontakte filtern",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "UND",
      "OR": "ODER"
    },
    "OPERATOR_LABELS": {
      "equal_to": "Gleich",
      "not_equal_to": "Nicht gleich",
      "contains": "Enthält",
      "does_not_contain": "Beinhaltet nicht",
      "is_present": "Ist anwesend",
      "is_not_present": "Ist nicht anwesend",
      "is_greater_than": "Ist größer als",
      "is_lesser_than": "Ist kleiner als",
      "is_greater_than_or_equal": "Ist größer oder gleich",
      "is_less_than_or_equal": "Ist kleiner oder gleich",
      "newer_than_days": "Ist neuer als x Tage (einschließlich)",
      "older_than_days": "Ist älter als x Tage (einschließlich)"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Wert ist erforderlich"
    },
    "ATTRIBUTES": {
      "NAME": "Name",
      "EMAIL": "E-Mail",
      "PHONE_NUMBER": "Telefonnummer",
      "IDENTIFIER": "Identifizierer",
      "CITY": "Stadt",
      "COUNTRY": "Land",
      "CUSTOM_ATTRIBUTE_LIST": "Liste",
      "CUSTOM_ATTRIBUTE_TEXT": "Text",
      "CUSTOM_ATTRIBUTE_NUMBER": "Nummer",
      "CUSTOM_ATTRIBUTE_LINK": "Link",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Checkbox",
      "CREATED_AT": "Erstellt am",
      "LAST_ACTIVITY": "Letzte Aktivität",
      "REFERER_LINK": "Verweis-Link",
      "BLOCKED": "Blockiert"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standardfilter",
      "ADDITIONAL_FILTERS": "Zusätzliche Filter",
      "CUSTOM_ATTRIBUTES": "Benutzerdefinierte Attribute"
    }
  }
}
